import { Button, IconBarChartVer, IconCode, IconImage, IconVideo } from '@screentone/core';

import { toTitleCase } from 'utils/case';
import { MediaTypes } from '../MediaInput.utils';

type Props = {
  variant: MediaTypes;
  isIdFormOpen: boolean;
  setIsIdFormOpen: (isOpen: boolean) => void;
  setVariant: (variant: MediaTypes | '') => void;
  disabled: boolean;
};

export const MediaInputButton = ({ variant, isIdFormOpen, setIsIdFormOpen, disabled, setVariant }: Props) => {
  function getIcon() {
    switch (variant) {
      case 'image':
        return IconImage;
      case 'video':
        return IconVideo;
      case 'chart':
        return IconBarChartVer;
      case 'iframe':
        return IconCode;
      default:
        return IconImage;
    }
  }

  return (
    <div data-testid="media-button-wrapper">
      <Button
        disabled={isIdFormOpen || disabled}
        tertiary
        data-testid={`media-button-${variant}`}
        icon={getIcon()}
        onClick={() => {
          setIsIdFormOpen(!isIdFormOpen);
          setVariant(variant);
        }}
      >
        Add {toTitleCase(variant)}
      </Button>
    </div>
  );
};
